import React from 'react';

const PauseIconVideo = (args) => (
  <svg
    width="54"
    height="53"
    viewBox="0 0 54 53"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...args}
  >
    <path
      d="M52.2509 26.2339C52.2509 40.1562 40.792 51.4678 26.6254 51.4678C12.4589 51.4678 1 40.1562 1 26.2339C1 12.3115 12.4589 1 26.6254 1C40.792 1 52.2509 12.3115 52.2509 26.2339Z"
      stroke="white"
      strokeOpacity="0.5"
      strokeWidth="2"
    />
    <path
      d="M24.6984 18.2911L21.9984 18.2911L21.9984 33.8611L24.6984 33.8611L24.6984 18.2911ZM31.4784 18.2911L28.7784 18.2911L28.7784 33.8611L31.4784 33.8611L31.4784 18.2911Z"
      fill="white"
      fillOpacity="0.5"
    />
  </svg>
);

export default PauseIconVideo;
